// chrome.exe --user-data-dir="C:/Chrome dev session" --disable-web-security
const prefix = 'REACT_APP_'

function env(key, defaultValue) {
  const envVal = process.env[`${prefix}${key}`] || defaultValue //test123
  if (!envVal) {
    throw new Error(`Environment variable ${key} missing with no default value`)
  }
  return envVal
}

const configurations = {
  redirectBaseUrl: env('REDIRECT_BASE_URL'),
  clientId: env('CLIENT_ID'),
  oidcConfigUrl: env('OIDC_CONFIG_URL'),
  apiUrl: env('API_BASE_URL'),
  subPath : env('SUB_PATH'),
  // ideaScoutSubPath : env('IDEA_SCOUT_SUB_PATH'),
  msaUrl: env('BASE_URL'),
  paths: {
    oidcAuthCodePKCE: env("REACT_APP_OIDC_IMPLICIT_PATH", "/oidc/auth-code-pkce"),
    oidcImplicit: env("REACT_APP_OIDC_IMPLICIT_PATH", "/oidc/implicit"),
    oidcFirmMember: env("REACT_APP_OIDC_FIRM_MEMBER_PATH", "/oidc/firm-user"),
    oidcAuthCode: env("REACT_APP_OIDC_IMPLICIT_PATH", "/oidc/auth-code"),
  }
}

export default configurations;